import { Component, ViewChild } from "@angular/core";
import {
  NavController,
  NavParams,
  Slides,
  AlertController,
} from "ionic-angular";
import { ModalController } from "ionic-angular";
import { BehaviorSubject, config, Subscription } from "rxjs";
import { TrendExplorer_2Page } from "../trend-explorer-2/trend-explorer-2";
import { EquipmentDetailsPage } from "../equipment-details/equipment-details";
import { TimeProvider } from "../../providers/time/time";
import { StarmsClientProvider } from "../../providers/starms-client/starms-client";
import { forkJoin } from "rxjs/observable/forkJoin";
import Enumerable from "linq";
import * as moment from "moment";
import { ApplicationApiProvider } from "../../providers/application-api/application-api";
import { TimeParams } from "../../models/TimeParams";
import { EntitiesProvider } from "../../providers/entities/entities";
import { Train } from "../../app/models/Train";
import { TemplateProvider } from "../../providers/template/template";
import { LdsClientService } from "../../providers/lds-client/lds-client.service";
import { OpServiceService } from "../../providers/lds-client/op-service.service";
import { ToastController } from "ionic-angular";
import { map } from "rxjs/operators";
import { Signaltag } from "../../models/trend-live-models/OPTag";

@Component({
  selector: "page-train-overview",
  templateUrl: "train-overview.html",
})
export class TrainOverviewPage {
  train: Train;
  equipmentList: Array<any> = [];
  equipmentReady = false;
  signalOperations: Array<any> = [];
  signalOperationsready = false;
  noSignals = false;
  refresher: any;
  timeParams: any;
  selectedEquipment = 0;
  signals: any = [];
  refreshEvent: BehaviorSubject<TimeParams> = new BehaviorSubject<TimeParams>(
    null
  );
  opSubscription: Subscription[] = [];
  visibility: any;
  activeRequests: Subscription[] = [];
  productLine: String;
  isAGT: boolean;
  visibilities = new Map<number, boolean>();
  templateConfig: any;
  showTimeSelector: boolean;
  @ViewChild(Slides) slides: Slides;
  equipmentTimeZone: string;
  ldsSubscription: any;
  subscriptionStatus = 0;
  liveDataCapabilities: boolean;
  loading: boolean;
  operationalProfile: any;
  ldsSignals: any;
  private _config: any;
  agtPerformanceDegradation = [
    {
      tagName: "A63GG30_D2MLM",
      tagDescription: "",
      tagId: null,
      tagData: [],
    },
    {
      tagName: "A54MW_D2MLM_COR",
      tagDescription: "",
      tagId: null,
      tagData: [],
    },
    {
      tagName: "A54MW_D2MLM_COR_AVG",
      tagDescription: "",
      tagId: null,
      tagData: [],
    },
  ];
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private modalCtrl: ModalController,
    private appApi: ApplicationApiProvider,
    private time: TimeProvider,
    private starms: StarmsClientProvider,
    private entitiesProvider: EntitiesProvider,
    private alertCtrl: AlertController,
    private templateProvider: TemplateProvider,
    private lds: LdsClientService,
    private opServ: OpServiceService,
    public toastCtrl: ToastController
  ) {
    this.timeParams = this.time.getTimeParams(30);
  }

  ionViewDidLoad(): void {
    this.train = this.entitiesProvider.currentEntity as Train;
    this.fetchConfig(this.train.getId());
    // this.lds.setUpWebSocket();
    this.getEquipment();
    // this.getSignalOperations();
    this.productLine = this.train.assignedPl;
    if (this.productLine === "AGT") {
      this.isAGT = true;
    } else {
      this.isAGT = false;
    }

    this.getTemplate();
  }

  chartLoaded(event) {
    // this.subscriptionStatus = 3;
    this.signals[event].ready = true;
  }

  getEquipment(): void {
    this.equipmentList = [];
    this.equipmentReady = false;
    let r1 = this.starms
      .get(["equipment/trains", this.train.getId()])
      .subscribe((equipment) => {
        for (let eq of equipment) {
          if (eq.productFamily == null) {
            eq.img = "assets/equipment/No-image.png";
          } else {
            eq.img = "assets/equipment/" + eq.productFamily + ".png";
          }
          this.equipmentList.push(eq);
        }
        this.selectedEquipment = 0;
        this.equipmentReady = true;
      });
    this.activeRequests.push(r1);
  }

  fetchConfig(trainId: number) {
    this.opServ.fetchConfig(trainId).subscribe((config) => {
      this.signalOperations = config.operationalProfile;
      this.getSignalOperations(config);
      this._config = config;
      this.loading = false;
      // this.startStream(config);
      return config;
    });
  }
  // startStream(config) {
  //   if (config.dataSource) {
  //     this.liveDataCapabilities = true;
  //     //this.liveDataCapabilitiesStatus = 'Preparing live data';
  //     this.equipmentTimeZone = config.timezone;
  //     this.subscriptionStatus = 1;
  //     this.lds.setUpWebSocket();
  //     this.lds.socketReady.subscribe((ready) => {
  //       if (ready) {
  //         this.subscriptionStatus = 2;
  //         this.lds
  //           .createStreamingSubscription(config.dataSource)
  //           .subscribe((subscription) => {
  //             this.ldsSubscription = subscription.subscriptionId;
  //             //   this.lds.stream.subscribe(stream => {
  //             //     if (stream.subscriptionId === this.ldsSubscription) {
  //             //       console.log('train-overview',stream)
  //             //       this.subscriptionStatus = 3;

  //             //     }
  //             //   })
  //           });
  //       }
  //     });
  //   }
  // }

  ngOnDestroy() {
    // When components is destroyed we need to stop the current lds subscription for tags data
    // this.lds.stopSubscription(this.ldsSubscription).subscribe(response => {
    //   console.log(`Subscription ${this.ldsSubscription} has been stopped.`);
    // }, error => {
    //   console.log(`Unscrubscribe error`, error);
    // });
  }

  getSignalOperations(config): void {
    for (let signal of config.operationalProfile) {
      this.signals[signal.tagAlias] = signal;
    }

    if (config.operationalProfile.length === 0) {
      this.noSignals = true;
    }
    this.signalOperationsready = true;
    this.prepareOperationalProfile();
  }

  onTimeChanges(timeParams: TimeParams) {
    for (let o of this.opSubscription) {
      o.unsubscribe();
    }
    this.cancelActiveRequests();
    this.timeParams = timeParams;
    this.refreshEvent.next(timeParams);
    this.prepareOperationalProfile();
  }

  cancelActiveRequests() {
    for (let request of this.activeRequests) {
      request.unsubscribe();
    }
    this.activeRequests = [];
  }

  openEquipmentDetails(eq): void {
    this.modalCtrl
      .create(EquipmentDetailsPage, {
        equipment: eq,
      })
      .present();
  }

  openTrendExplorer(source: any, tag: any): void {
    const initialData = source;

    this.modalCtrl
      .create(TrendExplorer_2Page, {
        initialData: initialData,
        initialTagChanges: {
          tag: tag,
          tags: this.signals.map((entry) => {
            entry.trendExplorer.added = false;
            return entry;
          }),
          subscription: this.ldsSubscription,
        },
      })
      .present();
  }

  private prepareOperationalProfile(): void {
    let self = this;
    for (let s in this.signals) {
      if (this.signals.hasOwnProperty(s)) {
        this.signals[s].ready = false;
        let opSubscription = forkJoin(
          this.starms.get(["signals/tags", this.signals[s].tagId], {
            filter: "optim",
            to: this.timeParams.to,
            from: this.timeParams.from,
          })
        ).subscribe(
          ([current]) => {
            let previous = {
              tag: {
                isStep: false,
              },
              tagData: [],
            };
            this.signals[s].current = Enumerable.from(current.tagData)
              .select(function (x) {
                return [Date.parse(x["siteTime"]), x.value];
              })
              .toArray();
            this.signals[s].currentType = current.tag.isStep
              ? "line"
              : "spline";
            this.signals[s].previous = Enumerable.from(previous.tagData)
              .select(function (x) {
                return [
                  moment(x["siteTime"])
                    .add(Math.abs(self.timeParams.range), "d")
                    .valueOf(),
                  x.value,
                ];
              })
              .toArray();
            this.signals[s].previousType = previous.tag.isStep
              ? "line"
              : "spline";
            this.signals[s].ready = true;
            this.signals[s].series = [
              {
                data: this.signals[s].current,
                color: "#4D217A",
                name: "Current",
                type: current.tag.isStep ? "line" : "spline",
              },
              {
                data: this.signals[s].previous,
                color: "#F6E600",
                name: "Previous",
                type: previous.tag.isStep ? "line" : "spline",
              },
            ];
          },
          () => {
            this.appApi.showToast(
              "Error while obtaining operatiol profile data"
            );
          }
        );
        this.opSubscription.push(opSubscription);
      }
    }
  }

  onRefresh(refresher: any): void {
    for (let o of this.opSubscription) {
      o.unsubscribe();
    }
    this.refresher = refresher;
    this.refreshEvent.next(this.timeParams);
    this.getEquipment();
    this.prepareOperationalProfile();
    refresher.complete();
  }

  getTemplate(): void {
    this.templateConfig = {
      equipmentTrain:
        this.templateProvider.currentTemplate.Train.EquipmentTrain,
      operationalProfile:
        this.templateProvider.currentTemplate.Train.OperationalProfile,
    };

    this.showTimeSelector =
      this.templateProvider.hasKPIs || this.templateProvider.hasOP;
  }
  presentToast() {
    const toast = this.toastCtrl.create({
      message:
        "New values are being streamed from your equipment every second!",
      duration: 3000,
    });
    toast.present();
  }
  presentLoadingToast() {
    const toast = this.toastCtrl.create({
      message: "Live data is being configured..",
      duration: 3000,
    });
    toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/train-overview/train-overview.ts